import { Clock, XCircle, LogOut } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../shared/Button';

type PendingApprovalProps = {
  status: 'pending' | 'rejected';
};

export default function PendingApproval({ status }: PendingApprovalProps) {
  const { user, signOut } = useAuth();
  const isRejected = status === 'rejected';

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          <div
            className={`w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4 ${
              isRejected ? 'bg-red-50' : 'bg-amber-50'
            }`}
          >
            {isRejected ? (
              <XCircle className="w-7 h-7 text-red-600" />
            ) : (
              <Clock className="w-7 h-7 text-amber-600" />
            )}
          </div>

          <h1 className="text-xl font-bold text-gray-900 mb-2">
            {isRejected ? 'Solicitud rechazada' : 'Cuenta pendiente de aprobación'}
          </h1>

          <p className="text-gray-600 text-sm mb-1">
            {isRejected
              ? 'Tu solicitud fue rechazada por el administrador.'
              : 'Tu cuenta está pendiente de aprobación por el administrador.'}
          </p>

          {user?.email && (
            <p className="text-gray-500 text-sm mb-6">{user.email}</p>
          )}

          {!isRejected && (
            <p className="text-gray-500 text-xs mb-6">
              Te avisaremos apenas puedas ingresar. No necesitas hacer nada más.
            </p>
          )}

          <Button variant="secondary" fullWidth icon={<LogOut />} onClick={() => signOut()}>
            Cerrar sesión
          </Button>
        </div>
      </div>
    </div>
  );
}
